/**
 * Bypass de expediente de proveedor (front C-NEW-03 / SP-212, back SP-213).
 *
 * Endpoints internos: usan `access_token` (staff), no el token del portal de
 * proveedores — de ahí que esto viva aparte de supplierProfile.service.ts.
 */

import { apiRequest, API_URL } from '@/shared/lib/apiUtils';

// Mínimo que valida el back (422 si no se cumple).
export const MIN_BYPASS_REASON = 20;

export interface BypassHistoryEntry {
  id: string;
  reason: string;
  createdAt: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
}

// El GET devuelve estado e historial en un solo objeto.
export interface SupplierBypassState {
  bypassActive: boolean;
  bypassReason: string | null;
  // Últimos 10 registros, del más reciente al más antiguo.
  history: BypassHistoryEntry[];
}

export interface ActivateBypassResponse {
  bypassActive: boolean;
  bypassReason: string;
}

const bypassUrl = (supplierId: string) =>
  `${API_URL}/internal/suppliers/${supplierId}/bypass`;

export const getSupplierBypass = (supplierId: string): Promise<SupplierBypassState> =>
  apiRequest<SupplierBypassState>(bypassUrl(supplierId));

/**
 * Activa el bypass. El back responde 403 sin permiso, 422 si `reason` trae
 * menos de MIN_BYPASS_REASON caracteres y 404 si el proveedor no existe.
 */
export const activateSupplierBypass = (
  supplierId: string,
  reason: string
): Promise<ActivateBypassResponse> =>
  apiRequest<ActivateBypassResponse>(bypassUrl(supplierId), {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
